var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.547,
    height: 21.5,
    viewBox: "0 0 25.547 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#001f4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.838 -913.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.816,919.646a3.16,3.16,0,1,1-6.316,0v-1.872a3.16,3.16,0,1,1,6.316,0Z",
    transform: "translate(0.627 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2.632,
    cy: 2.632,
    r: 2.632,
    transform: "translate(53.232 915.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.513,925.7a6.315,6.315,0,0,0-9.9,3.905,1.042,1.042,0,0,0,1.042,1.211h5.158",
    transform: "translate(0 0.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.917,925.5h0a8.423,8.423,0,0,0-8.337,7.224,1.059,1.059,0,0,0,1.052,1.2H71.2a1.059,1.059,0,0,0,1.052-1.2A8.423,8.423,0,0,0,63.917,925.5Z",
    transform: "translate(0.367 0.579)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/community-icon.35bee8cb156d3790af56aa82adfa0681.svg";
export { ForwardRef as ReactComponent };